import { MODULOS_CUPOM } from "./modulos";

// Bloco "Onde vale" do formulário do cupom: o lojista marca os módulos em que
// o cupom pode ser usado. Pelo menos um fica marcado.
export default function OndeVale({ modulos, onMudar }) {
  const marcados = modulos || [];
  const alternar = (key) => {
    const novo = marcados.includes(key) ? marcados.filter((m) => m !== key) : [...marcados, key];
    if (novo.length === 0) return;
    onMudar(MODULOS_CUPOM.map((m) => m.key).filter((m) => novo.includes(m)));
  };
  return (
    <div className="space-y-2" data-e2e="cupom-onde-vale">
      <p className="text-xs font-semibold">Onde vale</p>
      <p className="text-[11px] text-muted-foreground -mt-1">
        O cupom só é aceito nos módulos marcados — cada um vale só para si (Balcão não inclui o Totem; Mesas não inclui a Mesa QR). WhatsApp é o pedido anotado pela CLEO na conversa.
      </p>
      <div className="flex flex-wrap gap-2">
        {MODULOS_CUPOM.map((m) => {
          const ativo = marcados.includes(m.key);
          const Icone = m.icon;
          return (
            <button
              key={m.key}
              type="button"
              data-e2e={`cupom-modulo-${m.key}`}
              aria-pressed={ativo}
              onClick={() => alternar(m.key)}
              className={`flex items-center gap-1.5 px-3 py-1.5 rounded-lg text-xs font-medium transition-colors ${
                ativo ? "bg-orange-500 text-white" : "bg-muted text-muted-foreground hover:bg-muted/80"
              }`}
            >
              <Icone className="w-3.5 h-3.5" />
              {m.label}
            </button>
          );
        })}
      </div>
    </div>
  );
}
